// components/header.js
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Book, Home, Menu, X, Mail, HelpCircle, Brain, UserPlus } from 'lucide-react';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isLandingPage = location.pathname === '/';

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavigate = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const scrollToSubscription = () => {
    if (isLandingPage) {
      // Scroll to subscription section on landing page
      const subscriptionElement = document.getElementById('subscription-section');
      if (subscriptionElement) {
        subscriptionElement.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to landing page first, then scroll
      navigate('/');
      setTimeout(() => {
        const subscriptionElement = document.getElementById('subscription-section');
        if (subscriptionElement) {
          subscriptionElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm border-b sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div 
            className="flex items-center space-x-2 cursor-pointer"
            onClick={() => handleNavigate('/')}
          >
            <Book className="h-8 w-8 text-indigo-600" />
            <h1 className="text-2xl font-bold text-gray-900">
              CPR<span className="text-indigo-600">Refresh</span>
            </h1>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => handleNavigate('/quiz')}
              className="flex items-center space-x-2 text-gray-700 hover:text-indigo-600 font-medium transition-colors"
            >
              <Brain className="h-4 w-4" />
              <span>Take Quiz</span>
            </button>
            
            <button
              onClick={() => handleNavigate('/faq')}
              className="flex items-center space-x-2 text-gray-700 hover:text-indigo-600 font-medium transition-colors"
            >
              <HelpCircle className="h-4 w-4" />
              <span>FAQ</span>
            </button>
            
            <button
              onClick={scrollToSubscription}
              className="flex items-center space-x-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 font-medium transition-colors"
            >
              <UserPlus className="h-4 w-4" />
              <span>Get Reminders</span>
            </button>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 p-2"
            >
              {isMobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200 py-4">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => handleNavigate('/quiz')}
                className="flex items-center space-x-3 text-gray-700 hover:text-indigo-600 font-medium transition-colors py-2"
              >
                <Brain className="h-5 w-5" />
                <span>Take Quiz</span>
              </button>
              
              <button
                onClick={() => handleNavigate('/faq')}
                className="flex items-center space-x-3 text-gray-700 hover:text-indigo-600 font-medium transition-colors py-2"
              >
                <HelpCircle className="h-5 w-5" />
                <span>FAQ</span>
              </button>
              
              <button
                onClick={scrollToSubscription}
                className="flex items-center space-x-3 bg-indigo-600 text-white px-4 py-3 rounded-lg hover:bg-indigo-700 font-medium transition-colors"
              >
                <UserPlus className="h-5 w-5" />
                <span>Get Reminders</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;